import { useState } from 'react'
import { whatsAppCtaProps } from '../lib/analytics'
import { absoluteUrl } from '../lib/seo'

export function StorefrontUnavailable({ path, category, onRetry }: {
  path: string
  category?: string
  onRetry: () => Promise<unknown>
}) {
  const [retrying, setRetrying] = useState(false)
  const message = `Halo Dropify, saya ingin mengecek produk pada halaman ${absoluteUrl(path)}. Kebutuhan: ___. Kota tujuan: ___. Mohon bantuan admin.`
  return (
    <section className="mx-auto max-w-3xl rounded-xl border border-amber-200 bg-amber-50 p-6 text-slate-800" aria-label="Informasi pemuatan produk">
      <p role="status" className="font-semibold">Data produk belum bisa dimuat.</p>
      <p className="mt-2 text-sm">Coba lagi atau hubungi admin untuk mengecek produk yang Anda cari.</p>
      <div className="mt-4 flex flex-wrap gap-3">
        <button disabled={retrying} className="min-h-11 rounded-lg bg-slate-900 px-4 py-3 text-sm font-semibold text-white disabled:opacity-60" onClick={async () => {
          setRetrying(true)
          try { await onRetry() } catch { /* The route retains its recoverable error state. */ }
          finally { setRetrying(false) }
        }}>{retrying ? 'Memuat ulang…' : 'Coba lagi'}</button>
        <a className="min-h-11 rounded-lg bg-green-700 px-4 py-3 text-sm font-semibold text-white" href={`https://wa.me/6285704011028?text=${encodeURIComponent(message)}`} target="_blank" rel="noopener noreferrer" {...whatsAppCtaProps('landing_page', {
          cta_placement: 'load_error', ...(category ? { lp_category: category } : {}),
        })}>Tanya produk ke admin</a>
      </div>
    </section>
  )
}
